import type { CampaignSection, EmailTemplate } from 'types/content-editor'
import { getImageBlock } from './content-blocks'
import { columnTemplate } from './template-utils'
const footerSection: CampaignSection = {
  disableEditing: false,
  disableCopy: true,
  disableDelete: true,
  columns: [
    {
      columnContent: [
        {
          type: 'footer' as const,
          footer_id: null, // social: {
          //   iconColor: '#515151',
          //   facebook: '',
          //   twitter: 'https://twitter.com/discohq',
          // },
          // text:
          //   'You have received this email because you signed up to our newsletter list.',
        },
      ],
    },
  ],
}
const imageSection = {
  backgroundColor: '#f3f3f3',
  horizontalPadding: '25',
  verticalPadding: '25',
  columns: [
    {
      columnContent: [getImageBlock('')],
    },
  ],
}
const template1: CampaignSection[] = [
  imageSection,
  {
    columns: [
      {
        columnContent: [columnTemplate('Title text 1')],
      },
    ],
  },
  footerSection,
]
const template3: CampaignSection[] = [
  imageSection,
  {
    columns: [
      {
        columnContent: [columnTemplate('Title text 1', '')],
      },
      {
        columnContent: [columnTemplate('Title text 2', '')],
      },
    ],
  },
  footerSection,
]
export const templates: EmailTemplate[] = [
  {
    id: 't1',
    name: '1 Column',
    layout: template1,
  },
  {
    id: 't3',
    name: '2 Column',
    layout: template3,
  },
]
export const defaultCampaignTemplate: EmailTemplate = {
  id: null,
  layout: templates[0]!.layout, // 't1'
}
export const DEFAULT_CAMPAIGN_TEMPLATE_ID: string | null | undefined =
  templates[0]!.id
